export const AMENITIES_CODE = ''
export const ATTRACTIONS_CODE = 'M'
export const INSURANCES_CODE = 'A'

export const MAN_CODE = 'H'
export const WOMAN_CODE = 'F'
export const CHILD_CODE = 'K'
export const INFANT_CODE = 'I'


// WEBPACK FOOTER //
// ./src/components/booking/types.js